module.exports = __webpack_public_path__ + "static/media/card.8ee31ec7.svg";